(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function fit() {
      var h = document.querySelector('.header');
      if (!h) return;
      var nav = h.querySelector('.header__nav'), icons = h.querySelector('.header__icons'), logo = h.querySelector('.header__logo');
      h.classList.remove('header--collapse');
      if (!nav || getComputedStyle(nav).display === 'none') return;
      var n = nav.getBoundingClientRect(), i = icons.getBoundingClientRect(), l = logo.getBoundingClientRect();
      if (h.scrollWidth > h.clientWidth + 1 || n.right > i.left - 4 || n.left < l.right + 4) h.classList.add('header--collapse');
    }
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 100); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
    document.addEventListener('shopify:section:load', fit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Swap a YouTube/Vimeo poster for the real player (muted autoplay) */
    function embed(btn) {
      if (!btn || !btn.isConnected) return;
      var f = document.createElement('iframe');
      f.src = btn.getAttribute('data-video-embed');
      f.title = btn.getAttribute('aria-label') || 'Product video';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      btn.replaceWith(f);
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-video-embed]');
      if (btn) embed(btn);
    });

    /* Auto-play (muted) when the video scrolls into view, pause when it leaves */
    function setup(frame) {
      if (frame.dataset.autoplayReady) return;
      frame.dataset.autoplayReady = '1';
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var video = frame.querySelector('video');
          var poster = frame.querySelector('[data-video-embed]');
          if (en.isIntersecting && en.intersectionRatio >= 0.5) {
            if (poster) { embed(poster); return; }
            if (video) {
              video.muted = true;
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else if (video && !video.paused) {
            video.pause();
          }
        });
      }, { threshold: [0, 0.5] }).observe(frame);
    }
    function init() { document.querySelectorAll('[data-video-autoplay]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
/* v2.3: review wall — tap to pause on touch screens, keep clones out of tab order */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    document.querySelectorAll('[data-tm-clone] a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
    document.querySelectorAll('[data-tm]').forEach(function (wall) {
      wall.addEventListener('touchstart', function () { wall.classList.add('is-paused'); }, { passive: true });
      wall.addEventListener('touchend', function () { setTimeout(function () { wall.classList.remove('is-paused'); }, 2500); }, { passive: true });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
